import { createReducer, getItemAfterAsyncCall } from '@topconagriculture/frontend-utils';

import { getCodeList } from './code.actions';
import { CodeListNormalized } from './code.types';

export type CodeState = CodeListNormalized;

export const initialState: CodeState = {};

const codeReducer = createReducer(initialState, {
  [getCodeList.done.type]: (state: CodeState, action) => getItemAfterAsyncCall<CodeListNormalized>(state, action),
});

export default codeReducer;
